import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs/internal/Observable";
import {map} from "rxjs/operators";
import {AuthService} from "./auth-service";
import {UserRolePermissionsService} from "../common/user-role-permissions.service";
import {NavigationService} from "../Main/navigation.service";
import ISubSystemGroup = NCVIB.app.Main.Menu.Structure.ISubSystemGroup;

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {
    constructor(
        private authService: AuthService,
        private router: Router,
        private userRolePermissionsService: UserRolePermissionsService,
        private navigationService: NavigationService) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.isSignedIn() && this.isAuthorized(state.url);
    }

    isSignedIn(): Observable<boolean> {
        return this.authService.isSignedIn().pipe(
            map((isSignedIn) => {
                if (!isSignedIn) {
                    const currentPath = window.location.pathname + window.location.search;
                    this.router.navigate([
                        'login',
                        {queryParams: {url: currentPath}}
                    ]).then();
                    return false;
                }

                return true;
            }));
    }

    async isAuthorized(url: string) {
        while (!this.userRolePermissionsService.isInitialized) {
            // console.log("waiting for initialization of structure", url);
            await new Promise(resolve => setTimeout(resolve, 100));
        }

        let allGroups: ISubSystemGroup[] = this.navigationService.allSubSystemGroups(this.userRolePermissionsService.subSystemStructure!);
        return this.authService.isAuthorized(url, true, allGroups).pipe(
            map((isAuthorized) => {
                return isAuthorized;
            }));
    }
}
